/**
 * Brand — build-time source of truth for the widget.
 *
 * Values come from VITE_BRAND_* (apps/widget/.env), inlined by Vite at build.
 * A rebrand of the widget = change VITE_BRAND_SLUG / VITE_BRAND_NAME + rebuild.
 * Keep BRAND_SLUG in sync with the backend BRAND_SLUG (apps/api config/brand.php)
 * so the custom element tag the API embeds matches the tag this bundle registers.
 */
export const BRAND_SLUG: string = import.meta.env.VITE_BRAND_SLUG ?? 'kobot';
export const BRAND_NAME: string = import.meta.env.VITE_BRAND_NAME ?? 'Kobot AI';

/** Brand site domain (mirrors backend BRAND_DOMAIN). Drives the "powered by" link. */
export const BRAND_DOMAIN: string = import.meta.env.VITE_BRAND_DOMAIN ?? 'kobot.chat';
export const BRAND_URL = `https://${BRAND_DOMAIN}`;

/** Custom element tag, e.g. `kobot-chat-widget`. */
export const WIDGET_TAG = `${BRAND_SLUG}-chat-widget`;

/** AI search box custom element tag, e.g. `kobot-search`. */
export const SEARCH_TAG = `${BRAND_SLUG}-search`;
